import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  createBreadcrumbWithI18n,
  usePathParams,
} from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  PageContainer,
  type PageContainerProps,
} from '~/components/elements/PageContainer'
import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'
import { ensureExists } from '~/utils'

import { BasicOutputWizard } from './components'

const pathKey = 'basicOutputGeneration' as const

export const BasicOutputGenerationPage = checkCurrentSurvey(() => {
  const { t } = useTranslation()
  const { surveyId } = usePathParams(pathKey)

  const { isLoading } = useSurveyQuery()

  useLogEventOnMount('Access to basic output generation')

  const createBreadcrumb = React.useMemo(() => createBreadcrumbWithI18n(t), [t])
  const breadcrumbs = React.useMemo<PageContainerProps['breadcrumbs']>(
    () => [
      createBreadcrumb('top', {}),
      createBreadcrumb('basicAnalysis'),
      createBreadcrumb(pathKey, {
        surveyId: ensureExists(surveyId, t('assertion_failed')),
      }),
    ],
    [createBreadcrumb, surveyId, t],
  )

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <Suspense loading={isLoading}>
        <BasicOutputWizard
          surveyId={ensureExists(surveyId, t('assertion_failed'))}
        />
      </Suspense>
    </PageContainer>
  )
})
